class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    this.input.addEventListener(
      'input',
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this),
    );
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(
      `/search/suggest?q=${searchTerm}&section_id=predictive-search&resources[options][fields]=title,product_type,vendor,variants.title,variants.sku,tag`,
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;

        this.predictiveSearchResults.innerHTML = resultsMarkup;

        // ✅ Call this after HTML is injected
        if (window.StampedFn && typeof StampedFn.loadBadges === 'function') {
          StampedFn.loadBadges();
        }

        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
    document.body.style.overflow = 'auto';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);

document.addEventListener('DOMContentLoaded', function () {
  const tabButtons = document.querySelectorAll('.tab-button');
  const tabContents = document.querySelectorAll('.tab-content');

  // Utility: Hide all tabs except active
  function setupInitialTabContent() {
    tabContents.forEach((content) => {
      if (!content.classList.contains('active')) {
        content.style.display = 'none';
      } else {
        content.style.display = 'flex'; // or 'block' depending on your layout
      }
    });
  }

  // Utility: Style tab buttons
  function setupInitialTabButtons() {
    tabButtons.forEach((btn) => {
      if (btn.classList.contains('active')) {
        btn.classList.add('text-body-3-medium');
        btn.classList.remove('text-body-3-regular');
      } else {
        btn.classList.add('text-body-3-regular');
        btn.classList.remove('text-body-3-medium');
      }
    });
  }

  // Event Delegation for .tab-button clicks (including dynamically added ones)
  document.body.addEventListener('click', function (event) {
    const clickedTab = event.target.closest('.tab-button');
    if (!clickedTab) return;

    const selectedTab = clickedTab.getAttribute('data-tab');

    // Update tab button classes
    document.querySelectorAll('.tab-button').forEach((btn) => {
      btn.classList.remove('active', 'text-body-3-medium');
      btn.classList.add('text-body-3-regular');
    });

    clickedTab.classList.add('active', 'text-body-3-medium');
    clickedTab.classList.remove('text-body-3-regular');

    // Update tab content
    document.querySelectorAll('.tab-content').forEach((content) => {
      if (content.getAttribute('data-tab-content') === selectedTab) {
        content.classList.add('active');
        content.style.display = 'flex'; // Or 'block'
      } else {
        content.classList.remove('active');
        content.style.display = 'none';
      }
    });
  });

  setupInitialTabButtons();
  setupInitialTabContent();
});